import { getInitials } from "utils/stringUtils";
import { Flex, Image } from "@chakra-ui/react";
import type { AvatarImageProps } from "./AvatarImage.d";

export const AvatarImage = ({ avatarSrc, author }: AvatarImageProps) =>
  avatarSrc ? (
    <Image src={avatarSrc} w={12} h={12} mr={4} borderRadius="50%" loading="lazy" alt="" />
  ) : (
    <Flex
      w={12}
      h={12}
      borderRadius="50%"
      mr={4}
      justify="center"
      align="center"
      bg="greyscale.500"
      color="white"
      fontSize="lg"
      fontWeight="semibold"
    >
      {getInitials(author)}
    </Flex>
  );
